import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import fetchCompany from '../api/fetchCompany';
import type { ApiResponse } from '../../../types/apiResponse';
import type { Company } from '../types';
import withPrefix from '../../../helpers/useQueryPrefix';

export const useFetchCompany = (): UseQueryResult<Company> => {
  return useQuery<ApiResponse<Company>, Error, Company>({
    queryKey: withPrefix(['company']),
    queryFn: fetchCompany,
    select: (response) => {
      if (response.status !== 200) {
        throw new Error(response.message);
      }
      return response.data as Company;
    },
  });
};
